<template>
    <div>
        <div class="page-list-box">
            <el-table
                :data="data"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
                
            >			
				<el-table-column prop="activityId" label="演出ID"></el-table-column>  
				<el-table-column prop="activityTitle" label="演出名称" min-width="150" show-overflow-tooltip></el-table-column> 
				<el-table-column prop="startSellTime" label="开票时间" min-width="150" ></el-table-column> 
				<el-table-column prop="performerList" label="艺人阵容/艺人热度" min-width="150" >
					 <template slot-scope="scope">
						 <div v-for="(item, index) in scope.row.performerList" :key="index" class="MT10">
							<!-- <el-tag size="small" type="info"  effect="plain">
								  <span v-if="item.name">{{item.name}}</span>
							 </el-tag> <span class="color-danger">/{{item.hotLevel}}</span> -->
						 <span v-if="item.name">{{item.name}}</span>
						 <span class="line">/</span>
						 <span class="color-danger">{{item.hotLevel}}</span>
						</div>
					</template>					
				</el-table-column> 
				
				<el-table-column prop="wishNum" label="收藏数"></el-table-column> 
				<el-table-column prop="accessNum" label="PV"></el-table-column> 
				<el-table-column prop="startRecordNum" label="开票提醒"></el-table-column> 
				<el-table-column prop="ticketRecordNum" label="缺票登记"></el-table-column>				
				<el-table-column prop="hotLevel" label="人工设置热度"></el-table-column>
				<el-table-column prop="sellTicketHot" label="售票时热度"></el-table-column>
				<el-table-column prop="hot" label="热度取值"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    components:{},
    data(){
        return{
            data: null,
            dataList: null,           
            listLoading: true,           
            ids:null,
            
        }
    },
    computed:{
    
    },
    mounted() {
        this.getDataList();
       
    },
    methods:{
        
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/dashboard/activityHotData",
                method: "POST",
                data: {
                    
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        
    }
}
</script>
<style lang="scss" scoped>
.attach-list{
    .el-col{
        margin-top: 10px;
        width: 80px;
        height: 80px;
        .el-image{
            width: 100%;
            height: 100%;
        }
    }
}
.line{
	color:#f00;
	padding:0 3px;
	font-weight: bold;
}
</style>